export const MARK_PANEL_WIDTH_CLASS = 'w-96';

export const MARK_PANEL_Z_INDEX_CLASS = 'z-[60]';

export const MARK_PANEL_TITLE = 'Ask MARK';

export const MARK_PROMPTS_LABEL = 'Start with...';

export const MARK_PANEL_CLOSE_ARIA_LABEL = 'Close Ask MARK';

export const MARK_FLOATING_BUTTON_HINT_ID = 'mark-floating-button';

export const MARK_NEW_CHAT_CONFIRMATION_TITLE = 'Start a new chat';

export const MARK_NEW_CHAT_CONFIRMATION_BODY =
  'Chat will be started with the selected context. Your previous conversation will remain in';

export const MARK_NEW_CHAT_CONFIRMATION_HISTORY_LOCATION =
  'Ask MARK/Session History.';

export const MARK_NEW_CHAT_CONFIRMATION_SUBMIT_LABEL = 'Start a new chat';

export const MARK_NEW_CHAT_CONFIRMATION_CLOSE_ARIA_LABEL = 'Close';

export const MARK_OPEN_COUNT_KEY_PREFIX = 'mv-mark-open-count';

export const MARK_FLOATING_BUTTON_ATTENTION_MAX_OPENS = 3;
